/**
 * Typed surface for LaunchDarkly flags consumed in this app.
 *
 * Add a field here when you introduce a flag, then read it with
 * `useFlags<FeatureFlags>()` from `launchdarkly-react-client-sdk`.
 * Flag names follow the HqO kebab-case-in-LD → camelCase-in-code convention
 * (see anthropic-skills:hqo-launchdarkly).
 */
export interface FeatureFlags {
  /**
   * Master gate for routing tenant-portal traffic to the V2 miniapp.
   * Tracked in SMB-665 (host integration); off by default per building.
   */
  enableServiceBookingV2Tenant: boolean;
  /**
   * SMB-1844: per-session price in the session list, the "From $X" /
   * "Free – $X" footer range and the scarcity styling. Off = today's behaviour.
   */
  enableEventsSessionPricing: boolean;
}

export const LAUNCH_DARKLY_ANONYMOUS_KEY = 'anonymous@hqo.co';
